import styled from 'styled-components';

import typography from './typography';
import palette from './palette';

const HeadlineBase = styled.div`
  text-transform: uppercase;
  font-weight: 700;
  color: ${palette.darkBlue1};
  font-family: ${typography.family};
`;

const HeaderTwo = styled(HeadlineBase)`
  font-size: ${typography.headerTwo.size};
  line-height: ${typography.headerTwo.height};
`;

const HeaderFour = styled(HeadlineBase)`
  font-size: ${typography.headerFour.size};
  line-height: ${typography.headerFour.height};
`;

const BodyBase = styled.div`
  color: ${palette.darkGray1};
  font-family: ${typography.family};
  font-weight: 400;
`;

const BodyFour = styled(BodyBase)`
  font-size: ${typography.bodyFour.size};
  line-height: ${typography.bodyFour.height};
`;

export { HeaderTwo, HeaderFour, BodyFour };
